require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconInfoCircle.tsx
var IconInfoCircle_exports = {};
__export(IconInfoCircle_exports, {
  default: () => IconInfoCircle_default
});
module.exports = __toCommonJS(IconInfoCircle_exports);

// src/assets/monochrome/infoCircle.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgInfoCircle = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2 10C17.2 13.9764 13.9764 17.2 10 17.2C6.02355 17.2 2.8 13.9764 2.8 10C2.8 6.02355 6.02355 2.8 10 2.8C13.9764 2.8 17.2 6.02355 17.2 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM8.9702 13.0857C8.9702 13.3585 9.07857 13.6201 9.27146 13.813C9.46436 14.0059 9.72598 14.1143 9.99877 14.1143C10.2716 14.1143 10.5332 14.0059 10.7261 13.813C10.919 13.6201 11.0273 13.3585 11.0273 13.0857V9.99997C11.0273 9.72718 10.919 9.46556 10.7261 9.27266C10.5332 9.07977 10.2716 8.9714 9.99877 8.9714C9.72598 8.9714 9.46436 9.07977 9.27146 9.27266C9.07857 9.46556 8.9702 9.72718 8.9702 9.99997V13.0857ZM9.14355 7.4857C9.03053 7.31656 8.9702 7.11769 8.9702 6.91426C8.9702 6.64147 9.07857 6.37984 9.27146 6.18695C9.46436 5.99406 9.72598 5.88569 9.99877 5.88569C10.2022 5.88569 10.4011 5.94601 10.5702 6.05903C10.7394 6.17205 10.8712 6.3327 10.949 6.52064C11.0269 6.70859 11.0473 6.9154 11.0076 7.11492C10.9679 7.31445 10.8699 7.49772 10.7261 7.64157C10.5822 7.78542 10.399 7.88338 10.1994 7.92307C9.99991 7.96275 9.7931 7.94239 9.60515 7.86454C9.41721 7.78668 9.25657 7.65485 9.14355 7.4857Z", fill: "#676F7E" }) });
var infoCircle_default = SvgInfoCircle;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconInfoCircle.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconInfoCircle = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(infoCircle_default, {}) });
};
IconInfoCircle.displayName = "IconInfoCircle";
var IconInfoCircle_default = IconInfoCircle;
